/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodWrrr = createReactComponent("outline", "mood-wrrr", "IconMoodWrrr", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1", "key": "svg-1" }], ["path", { "d": "M8.5 11.5l1.5 -1.5l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M15.5 11.5l-1.5 -1.5l1.5 -1.5", "key": "svg-3" }]]);

export { IconMoodWrrr as default };
//# sourceMappingURL=IconMoodWrrr.mjs.map
